/**
 * Resolves a state field name by joining non-empty parts with a dot.
 */
export function resolveStateFieldName(parts: string[]): string {
    return parts.filter(Boolean).join('.');
}
